import { render, staticRenderFns } from "./WsReviewDialog.vue?vue&type=template&id=ab333dfe&"
import script from "./WsReviewDialog.vue?vue&type=script&lang=js&"
export * from "./WsReviewDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports